import { withConfig } from "@/utils/withConfig";
import { YourAddress } from "./YourAddress";
import type { YourAddressProps } from "./YourAddressProps";

export * from "./YourAddress";
export * from "./YourAddressProps";

export const YourAddressWithConfig = withConfig<YourAddressProps>(
  YourAddress,
  "your_address",
);
